<template>
  <div class="line-items-table-body-line-items">
    <LineItem v-for="(lineItem, index) in lineItems"
              :key="index"
              v-bind="lineItem" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import LineItem from "./LineItem.vue";

export default {
  components: {
    LineItem
  },

  computed: {
    ...mapGetters("lineItemsTable", [
      "lineItems"
    ])
  }
};
</script>
